import React from "react";
import DeleteUser from "@/view/user/component/DeleteUser";

const DeleteUserView: React.FC = () => {
    return (
        <>
            <DeleteUser/>
        </>
    )
};

export default DeleteUserView;